module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triggers-integrations"
  }, [_c('div', {
    staticClass: "row description"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.title.trigger_stages')) + ":")])])])]), _c('div', {
    staticClass: "row"
  }, [(_vm.showIntegrationOnCreated()) ? _c('div', {
    staticClass: "col-md-8 left"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.toggleMark()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "created"
    },
    domProps: {
      "checked": _vm.on_created
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onCreated')))])])]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 left"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.toggleStatusTrigger()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "status_connected_trigger"
    },
    domProps: {
      "checked": _vm.status_connected_trigger
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onStatusConnected')))])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 left"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.toggleTrigger()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "trigger"
    },
    domProps: {
      "checked": _vm.trigger
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onAdvanceStage')) + ":")])])]), (_vm.trigger) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('stages-select', {
    attrs: {
      "integration": _vm.integration,
      "filter_item_selected_ids": _vm.filter_item_selected_ids
    },
    on: {
      "item-selected-items": _vm.itemSelectedItems
    }
  })], 1) : _vm._e()]), (_vm.integration == 'webhook') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 left"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.toggleResponsibilityTrigger()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "change_responsibility_trigger"
    },
    domProps: {
      "checked": _vm.on_change
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onChangeResponsibility')))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1e884d2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/trigger_stages.vue
// module id = 1192
// module chunks = 1